export const DISMISS = Symbol('DISMISS_TOAST')
export const ADD = Symbol('ADD_TOAST')

const dismiss = toastId => {
  return {
    type: DISMISS,
    payload: toastId,
  }
}

const add = ({ message, variant }) => {
  return {
    type: ADD,
    payload: { message, variant },
  }
}

export const actions = {
  add,
  dismiss,
}
